import Component from 'vue-class-component'
import PreviewContainerVue from './PreviewContainer'
import { IContainerData } from '../../store/editor/components/state'

@Component
export default class ColumnsVue extends PreviewContainerVue<IContainerData> {

  get itemSizes(): number[] {
    return this.componentData.itemSizes
  }

  getColumnWidthStyle(index: number): string {
    if (this.itemSizes && this.itemSizes.length > index) {
      const size = this.itemSizes[index]
      return `column-width--${size}`
    }
    return ''
  }
}
